import { useAuth } from '@modules/auth/hooks';
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { STUDY_INSIGHTS_CONSENTED_PARTICIPANTS_DATA } from '../constants';
import { Data } from '../components/ParticipantRecluitment/shared/types/PartnerConsentedParticipantData.types';
import { fetchPartnerConsentedParticipantsData } from '@modules/study-insights/services/partner-consented-participants-data.service';
import { FetchPartnerConsentParams } from '@modules/study-insights/components/ParticipantRecluitment/shared/types/participants.types';

const useQueryPartnerConsentedParticipantData = <TError = unknown>(
  params: FetchPartnerConsentParams,
  options?: Omit<
    UseQueryOptions<Data | undefined, TError, Data, Array<string | Date | undefined>>,
    'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<Data> => {
  const { isAuthenticated } = useAuth();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  return useQuery(
    [STUDY_INSIGHTS_CONSENTED_PARTICIPANTS_DATA, params.startDate, params.endDate],
    async () => await fetchPartnerConsentedParticipantsData(params),
    {
      ...options,
      enabled: isAuthenticated === true && enabledOption,
    },
  );
};
export default useQueryPartnerConsentedParticipantData;
